import { InputAdornment, TextField } from "@mui/material";
import { BsFileEarmarkPerson } from "react-icons/bs";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { PiCity } from "react-icons/pi";
import { IoIosPhonePortrait } from "react-icons/io";
import { IoMailOutline } from "react-icons/io5";
import { Transliteration } from "../common/Transliteration";

export default function ApplicantDataForm({
  formData,
  setFormData,
  formDataErrors,
}) {
  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
      }}
    >
      <TextField
        fullWidth
        placeholder="Име и презиме или Назив на правно лице"
        autoComplete="off"
        value={formData?.name || ""}
        onChange={(event) => {
          let value = event.target.value;
          if (window.localStorage.getItem("locale") === "mk") {
            value = Transliteration.toUpperCyrilic(value);
          } else {
            value = value.toUpperCase();
          }
          handleChange("name")({
            ...event,
            target: { ...event.target, value },
          });
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <BsFileEarmarkPerson size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.applicationName ? true : false}
        helperText={formDataErrors.applicationName || ""}
      />
      <TextField
        fullWidth
        placeholder="Адреса"
        autoComplete="off"
        value={formData?.headquarters || ""}
        onChange={(event) => {
          let value = event.target.value;
          if (window.localStorage.getItem("locale") === "mk") {
            value = Transliteration.toUpperCyrilic(value);
          } else {
            value = value.toUpperCase();
          }
          handleChange("headquarters")({
            ...event,
            target: { ...event.target, value },
          });
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <HiOutlineBuildingOffice size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.applicantAddress ? true : false}
        helperText={formDataErrors.applicantAddress || ""}
      />
      <TextField
        fullWidth
        placeholder="Град"
        autoComplete="off"
        value={formData?.city || ""}
        onChange={(event) => {
          let value = event.target.value;
          if (window.localStorage.getItem("locale") === "mk") {
            value = Transliteration.toUpperCyrilic(value);
          } else {
            value = value.toUpperCase();
          }
          handleChange("city")({
            ...event,
            target: { ...event.target, value },
          });
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PiCity size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.applicantPlace ? true : false}
        helperText={formDataErrors.applicantPlace || ""}
      />
      <TextField
        fullWidth
        placeholder="Телефон"
        autoComplete="off"
        value={formData?.phone || ""}
        onChange={(event) => {
          let value = event.target.value;
          if (window.localStorage.getItem("locale") === "mk") {
            value = Transliteration.toCyrilic(value);
          } else {
            value = value.toUpperCase();
          }
          handleChange("phone")({
            ...event,
            target: { ...event.target, value },
          });
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IoIosPhonePortrait size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.applicantPhone ? true : false}
        helperText={formDataErrors.applicantPhone || ""}
      />
      <TextField
        fullWidth
        placeholder="Е-пошта"
        autoComplete="off"
        value={formData?.email || ""}
        onChange={handleChange("email")}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IoMailOutline size={20} color="#b9b9b9" />
            </InputAdornment>
          ),
        }}
        error={formDataErrors.applicantEmail ? true : false}
        helperText={formDataErrors.applicantEmail || ""}
      />
    </div>
  );
}
